import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Navigate, useLocation } from 'react-router-dom';
import { validateAuthSession } from 'api/auth';

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState(() => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('authToken') : null;
    return token ? 'authenticated' : 'unauthenticated';
  });

  useEffect(() => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('authToken') : null;
    if (!token) {
      setStatus('unauthenticated');
      return undefined;
    }
    // Validate only once on mount, not on every route change
    validateAuthSession().then((valid) => {
      setStatus(valid ? 'authenticated' : 'unauthenticated');
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (status === 'checking') {
    return (
      <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (status === 'unauthenticated') {
    if (location.pathname.includes('/meetings/room/')) {
      return children;
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
